require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-drew-serving-assistant-turned-software-developer.json") })
        }
      }, "path---blog-meet-drew-serving-assistant-turned-software-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-drew-serving-assistant-turned-software-developer!./.cache/json/blog-meet-drew-serving-assistant-turned-software-developer.json
// module id = 968
// module chunks = 231608221292675